import { createFileRoute } from '@tanstack/react-router'
import { useCurrentAssistant } from '~/api'
import { AppDisabled } from '~/components/student/app/AppDisabled'
import { OpeningMessage } from '~/components/student/chat/OpeningMessage'
import { PendingMessage } from '~/components/student/chat/PendingMessage'
import { Topics } from '~/components/student/chat/Topics'

export const Route = createFileRoute('/student/courses/$courseId/apps/$appId/')({
	component: NewChat,
})

function NewChat() {
	const assistant = useCurrentAssistant()

	if (assistant != null && !assistant.isAvailableAndEnabledForRole) {
		return <AppDisabled />
	}

	return (
		<>
			<OpeningMessage />
			{assistant?.promptTemplates?.SOCRATIC != null && <Topics />}
			<PendingMessage />
		</>
	)
}
